import { render } from "./FormKyc.vue?vue&type=template&id=6b479d8c"
import script from "./FormKyc.vue?vue&type=script&lang=js"
export * from "./FormKyc.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__